import { useTenantProtectionEntitlement } from './useGetHasEntitlement.hook';
import { useProductStatus } from './useProductStatus.hook';
import { ProductsStatusKey } from '../@types/productsStatus';
import { getSessionStorageItem } from '../utils/session';

/**
 * IF User hasTenantProtection
 * AND Status == 'STARTED'
 * OR token valid
 */
export const useIsTenantProtectionAvailable = (): boolean => {
  const hasTenantProtection = useTenantProtectionEntitlement();
  const product = useProductStatus(ProductsStatusKey.TenantProtection);
  if (!hasTenantProtection) {
    return false;
  }
  const isSessionEntitledForTenantProtection = getSessionStorageItem('isSessionEntitledForTenantProtection') ?? false;
  return (product as any)?.status === 'STARTED' || isSessionEntitledForTenantProtection;
};
